import { UI } from "../constants/tokens";
import Icon from "./Icon";

// ─── Card kinds — one fixed icon + label at the head of every card ───────────
// Five kinds of card share the home and portfolio screens, and they used to
// look identical: same paper, same edge, a title in the same face. The reader
// had to read a card to learn what sort of thing it was. Now each kind wears
// the same small mark at its top, everywhere it appears, so it is recognised
// before it is read.
//
// Distinction by icon and label, not by colour: the palette has exactly four
// meanings (brand, interaction, selected, price movement) and a category is
// none of them. The one exception is the AI insight, whose gold is the
// brand's own mark for AI — that is what gold is for.
//
// `weekly` is deliberately its own kind and NOT "עדכון תיק" (David,
// 2026-09-23). Every other kind describes something that happened in the
// market or in the user's holdings; this one reports what the SYSTEM did —
// how many articles were scanned, how many events were classified. Filing it
// under a portfolio update would say the scan is a fact about the portfolio,
// which it is not, and would put the same label on two different kinds of
// claim on one screen.
export const CARD_KINDS = {
  // "כותרת", not "תובנת AI" (2026-09-26): the card quotes a headline a named
  // source published; calling it an insight presented it as ours.
  ai:        { label: "כותרת",              icon: "ai" },
  official:  { label: "מסמך רשמי",          icon: "bank" },
  geo:       { label: "מודיעין גיאופוליטי", icon: "globe" },
  portfolio: { label: "עדכון תיק",          icon: "wallet" },
  report:    { label: "דוח קרוב",           icon: "calendar" },
  weekly:    { label: "סיכום שבועי",        icon: "signal" },
};

export default function CardKind({ kind, gold = false, trailing = null, style = {} }) {
  const k = CARD_KINDS[kind];
  if (!k) return null;
  const color = gold ? UI.accent.base : UI.text.secondary;
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, ...style }}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <Icon name={k.icon} size={15} color={color}/>
        <span style={{ fontSize: 12.5, fontWeight: 800, color }}>{k.label}</span>
      </span>
      {trailing}
    </div>
  );
}
